import { isSupportedLanguage, type Language } from './config';

/** "/home" -> "/en/home" ; "/" -> "/en". */
export const localizePath = (language: Language, path: string): string =>
    `/${language}${path === '/' ? '' : path}`;

/** Retire le préfixe de langue : "/en/home" -> "/home", "/en" -> "/", "/home" -> "/home". */
export const stripLanguage = (pathname: string): string => {
    const [, first, ...rest] = pathname.split('/');
    return isSupportedLanguage(first) ? `/${rest.join('/')}` : pathname;
};

/** Même page dans une autre langue : "/fr/version" -> "/en/version". */
export const switchLanguage = (pathname: string, language: Language): string =>
    localizePath(language, stripLanguage(pathname));
